import classnames from 'classnames';
import React from 'react';
import { useHistory } from 'react-router-dom';
import DoubleRight from '@/assets/images/icons/double-right.react.svg?react';
import { useAppConfig } from '@/config/context';
import { ENV } from '@/infrastructure/env-config';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { useMobile } from '@/presentation/hooks/utils/mobile';
import styles from './index.module.scss';

enum MenuType{
  OVERSEAS='overseas',
  RESOURCE_PACK ='resourcePack',
  DOCS='docs'
}

export const Menu = () => {
  const config = useAppConfig();
  const history = useHistory();
  const [isMobile] = useMobile();
  const overseasClick = () => {
    reportClick(PAGE_ID.indexMain, CUSTOM_ACTIONS.commonEnterOverseas, {
      from: PAGE_ID.indexMain,
    });
    const a = document.createElement('a');
    a.href = 'https://bugly.tds.tencent.com/v2/index/main';
    a.target = '_blank';
    a.click();
  };

  const resourcePackClick = () => {
    reportClick(PAGE_ID.indexMain, CUSTOM_ACTIONS.commonEnterBuyResourcePackPage, {
      from: PAGE_ID.indexMain,
    });
    history.push('/resource-pack');
  };

  const docsClick = () => {
    window.open(config.docRoot, '_blank');
  };

  const onClick = (key: MenuType) => {
    switch (key) {
      case MenuType.OVERSEAS:
        overseasClick();
        break;
      case MenuType.RESOURCE_PACK:
        resourcePackClick();
        break;
      case MenuType.DOCS:
        docsClick();
        break;
    }
  };
  const menus = [
    {
      title: '海外版',
      key: MenuType.OVERSEAS,
      disabled: ENV.isEu,
    }, {
      title: '购买资源包',
      key: MenuType.RESOURCE_PACK,
      disabled: ENV.isOverseas,
    }, {
      title: '文档中心',
      key: MenuType.DOCS,
      disabled: false,
    },
  ]?.filter(item => !item.disabled);

  return <div className={classnames('w-full bg-[#EFF6FF] flex justify-center py-[24px]', styles.menu)}>
    {menus.map((item, index) => <div className={classnames({
      ['px-[50px] cursor-pointer relative py-[15px]']: true,
      [styles.divider]: index + 1 !== menus.length,
      [styles.menuItem]: isMobile,
    })} key={item.key} onClick={() => onClick(item.key)}>
        <span className={'text-[#4A5970] text-[20px] font-medium leading-[30px] align-bottom mr-[4px]'}>
          {item.title}
        </span>
        <DoubleRight/>
      </div>)}
  </div>;
};
